import { render, staticRenderFns } from "./AddCoursePricing.vue?vue&type=template&id=6b728872&scoped=true"
import script from "./AddCoursePricing.vue?vue&type=script&lang=js"
export * from "./AddCoursePricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b728872",
  null
  
)

export default component.exports